import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import Swal from "sweetalert2";
import ViewInfo from "./TestTopicInfoCreate.module.css";
import { AxiosInstance } from "../../../../../axios";
import Loader from "../../../Loader";
import { Modal } from "react-bootstrap";
import toast from "react-hot-toast";
import ConfirmationPopup from "../../TestAdminWorkflow/Gallery/ConfirmationPopup/ConfirmationPopup";
export default function ViewTestTopicInfo() {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const { FCAT, FTYPE, FCOUR, FSUB, FSEARCHTERM } = location.state || {};
  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;
  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    }
  } else {
    console.log("User Id cannot avaliable in session storage");
  }

  const [formFields, setFormFields] = useState({
    Category: "",
    GroupHeading: "",
    AdmissionType: "",
    CourseName: "",
  });
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedBooks, setSelectedBooks] = useState([]);
  useEffect(() => {
    setIsLoading(true);
    AxiosInstance.post("api/course/testview", { id: parseInt(id) })
      .then((res) => {
        if (res.data.status === true && res.data.data?.length > 0) {
          const testTopicData = res.data.data[0];
          setFormFields({
            TestTopicName: testTopicData.test_topic_name,
            Category: testTopicData.category_code,
            Subject: testTopicData.subject,
            AdmissionType: testTopicData.type,
            CourseName: testTopicData.course_name,
          });
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        return error;
      });
  }, [id]);

  const navigateToPreviousScreen = () => {
    navigate(-1); // Navigate back by one step in the history
  };
  const handleNavigate = (idsss) => {
    navigate(`/AddTestTopic/${idsss}`);
  };

  const handleBackFilter = () => {
    navigate(`/CourseManagement/3`, {
      state: {
        filCateCode: FCAT,
        filType: FTYPE,
        fillCourse: FCOUR,
        filSubject: FSUB,
        filSearch: FSEARCHTERM
      },
    });
  };
  const handleDelTestTopics = (e) => {
    e.preventDefault();
    setShowModal(true);
  };
  const handleClose = () => {
    setShowModal(false);
  };
  const handleSubmit = () => {

    // console.log(raiseQuery);
    AxiosInstance.post("api/course/delete/test_topics", { id: [parseInt(id)] }).then(
      (res) => {
        if (res.data.status === true) {
          toast.success(res.data.message);
          handleClose();
          navigate("/CourseManagement/3")
        } else {
          toast.error(res.data.message);
          handleClose();
        }
      }
    );
  }
  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (

    <>
      {showModal && (
        <ConfirmationPopup
          open={showModal}
          title="Remove Topic"
          message="Are you sure you want to remove this topic?"
          onConfirm={handleSubmit}
          onCancel={handleClose}
        />
      )}
      <div className={`${ViewInfo.CourseInfoSec} BathHeader global_container`}>
        <div className="row">
          <div className="col-md-6 col-12">
            <h2 className="TitleHeader">View Topic</h2>
          </div>
          <div className="col-md-6 col-12 ListBtn">
            <ul class="List-Button">
              <li class="ListBtnItems">
                <Link
                  onClick={handleBackFilter}
                  to="javascript:void(0)"
                  className="secondaryButton "
                  variant="secondary"
                >
                  Back to Course Management
                </Link>
              </li>
              <li class="ListBtnItems">
                <Link
                  to="javascript:void(0)"
                  className={`primaryButton `}

                  variant="primary"
                  onClick={handleDelTestTopics}
                >
                  Remove  Topic
                </Link>
              </li>
              <li class="ListBtnItems">
                <Link
                  to="javascript:void(0)"
                  // onClick={() => handleNavigate(id)}
                  onClick={() => handleNavigate(id)}
                  className="primaryButton"
                  variant="primary"
                >
                  {" "}
                  <span className="material-icons me-1 fs-5 align-middle text-white">
                    border_color
                  </span>{" "}
                  Edit  Topic
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="mb-4">
          <fieldset className="mt-3">
            <legend className="w-auto">Topic Details</legend>
            <div className="row mb-3">
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0"> Topic</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {formFields.TestTopicName || "_"}
                  </p>
                </div>
              </div>


              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Type of Admission</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {formFields.AdmissionType === "" && "_"}
                    {formFields.AdmissionType === 0 && "Course"}
                    {formFields.AdmissionType === 1 && "Test Batch"}
                    {formFields.AdmissionType === 2 && "Counselling"}
                    {formFields.AdmissionType === 3 && "Special Class"}
                    {formFields.AdmissionType === 4 && "Model Exam"}
                    {formFields.AdmissionType === 5 && "Mock Interview"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0"> Category</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {formFields.Category || "_"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0"> Course</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {formFields.CourseName || "_"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0"> Subject</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {formFields.Subject || "_"}
                  </p>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
        {/* <Modal show={showModal} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            <h5 class="view-title" id="exampleModalLabel">
              Remove Topic
            </h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container">
            <div className="row">
              <div className="col-md-12  mb-3">
                <div>
                  <p className="view-bold AddMargin">
                    Are you sure you want to remove the selected topic?
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <p className="cancel-button" onClick={handleClose}>
            Back to View  Topic
          </p>
          <button
            type="button"
            className="DashboardButton"
            onClick={handleSubmit}
          >
            <a href="javascript:void(0)">Yes, Remove</a>
          </button>
        </Modal.Footer>
      </Modal> */}
      </div>
    </>

  );
}
